export default __webpack_public_path__ + "static/media/guide_046.a605aa5b.md";